import React, { useMemo } from "react";
import howItWorks1 from "../img/howItWorks/howItWorks1.png";
import howItWorks2 from "../img/howItWorks/howItWorks2.png";
import howItWorks3 from "../img/howItWorks/howItWorks3.png";
import Model from "@tripian/model";

const stepData = [
  {
    stepNumber: 1,
    titleKey: "landing.howTripianWorks.createYourAccount.title",
    descriptionKey: window.location.href.includes("visa")
      ? "landing.viator.howTripianWorks.createYourAccount.description"
      : "landing.howTripianWorks.createYourAccount.description",
    image: howItWorks1,
  },
  {
    stepNumber: 2,
    titleKey: "landing.howTripianWorks.setUpYourTrip.title",
    descriptionKey: "landing.howTripianWorks.setUpYourTrip.description",
    image: howItWorks2,
  },
  {
    stepNumber: 3,
    titleKey: "landing.howTripianWorks.readyToGo.title",
    descriptionKey: "landing.howTripianWorks.readyToGo.description",
    image: howItWorks3,
  },
];

type Props = {
  t: (value: Model.TranslationKey) => string;
};

const GetStarted: React.FC<Props> = ({ t }) => {
  const steps = useMemo(
    () =>
      stepData.map(item => ({
        step: `${t("landing.howTripianWorks.step")} ${item.stepNumber}`,
        title: t(item.titleKey as Model.TranslationKey),
        description: t(item.descriptionKey as Model.TranslationKey),
        image: item.image,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <section className="bg-neutral-100 py-28 px-4 md:px-8 rounded-[5rem] ">
      <div className="text-center mb-16">
        <div className="flex flex-col items-center gap-2 mb-8 md:mb-4">
          <p className="text-[#1434CB] font-inter text-lg md:text-2xl font-semibold md:tracking-widest uppercase text-center">
            {t("landing.getStarted")}
          </p>
          <div className="w-12 h-[2px] bg-[#1434CB]" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mt-6">
          {t("landing.howItWorks.title")}
        </h2>
      </div>

      <div className="max-w-7xl mx-auto flex flex-col gap-12 md:gap-0">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row items-start md:items-center relative mb-6"
          >
            {/* Left Image */}
            <div className="w-full md:w-1/2 hidden md:flex justify-center md:justify-end pe-48">
              <img src={step.image} alt={step.title} className="w-56 h-auto" />
            </div>

            <div className="w-full md:w-1/2 flex -translate-x-2">
              <div className="hidden md:flex flex-col items-center pt-2 relative">
                {/* Dot */}
                <div className="w-7 h-7 bg-gray-300 rounded-full" />
                {/* Line */}
                <div className="w-[1px] h-72 bg-gray-300 mt-6" />
              </div>

              {/* Step Content */}
              <div className="text-center md:ps-48 md:text-left ">
                <span className="inline-block text-base md:text-lg bg-[#1434CB] text-white px-5 py-[0.35rem] md:py-2 rounded-full font-bold mb-6">
                  {step.step}
                </span>
                <h3 className="text-[1.625rem]/[1.75rem] md:text-3xl/[3.25rem] text-neutral-900 font-semibold mb-6">
                  {step.title}
                </h3>
                <p className="text-zinc-500 mt-2 text-lg/[2rem]  md:text-2xl/[2.5rem]">
                  {step.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GetStarted;
